/* =========================================================================
   MASTER HUB RENDERING & FILTERING ENGINE
   ========================================================================= */

function initHubLogic() {
  
  // Load the Merch Sort Map
  let sortMaps = [];
  const sortElement = document.getElementById('CollectionSortMaps');
  if (sortElement) {
    try {
      sortMaps = JSON.parse(sortElement.textContent);
    } catch (e) {
      console.warn("Hub Engine: Could not parse Collection Sort Map.");
    }
  }

  // 1. SAFELY LOAD DATA
  let hubData = [];
  const dataElement = document.getElementById('MasterHubData');
  
  if (dataElement) {
    try {
      hubData = JSON.parse(dataElement.textContent);
      console.log(`✅ Hub Engine: Successfully parsed ${hubData.length} items from Liquid!`);
    } catch (error) {
      console.error("❌ Hub Engine: FATAL ERROR parsing Liquid JSON data.", error);
    }
  } else {
    console.warn("⚠️ Hub Engine: Could not find the #MasterHubData element on the page.");
  }

  const gridContainer = document.getElementById('hub-grid');
  const filterButtons = document.querySelectorAll('.hub-icon-btn');
  const searchInput = document.getElementById('hub-search'); // Grab the new search bar

  if (!gridContainer) return; 

  // =======================================================================
  // 2. THE FILTER STATE (The "Brain" of the Engine)
  // =======================================================================
  let state = {
    requiredTags: [], // Empty array means 'all'
    searchText: ""
  };

  // The single unified function that applies both button tags AND search text
  function applyFilters() {
    let results = hubData;

    // Step A: Apply Button Filters
    if (state.requiredTags.length > 0) {
      results = results.filter(item => {
        return state.requiredTags.some(reqTag => {
          
          // 1. DYNAMIC MAP OVERRIDE: Is this tag a defined Collection Map? (e.g., 'bestselling')
          // If yes, bypass the tags string entirely and check if the item's handle is in the map!
          if (sortMaps[reqTag] && sortMaps[reqTag].length > 0) {
            return sortMaps[reqTag].includes(item.handle);
          }
          
          // 2. STANDARD CHECK: Look for exact tag match in the comma-separated string
          if (!item.tags) return false;
          const itemTagsArray = item.tags.split(',').map(t => t.trim().toLowerCase());
          return itemTagsArray.includes(reqTag);
        });
      });
    }

    // Step B: Apply Search Bar Text
    if (state.searchText !== "") {
      const query = state.searchText.toLowerCase();
      results = results.filter(item => {
        const titleMatch = item.title && item.title.toLowerCase().includes(query);
        const tagsMatch = item.tags && item.tags.toLowerCase().includes(query);
        
        // DYNAMIC MAP OVERRIDE: If they type exactly "bestselling", show the mapped items too!
        const mapMatch = (sortMaps[query] && sortMaps[query].includes(item.handle));

        return titleMatch || tagsMatch || mapMatch;
      });
    }

// Step B.5: THE DYNAMIC SORTING LAYER
    results.sort((a, b) => {
      
      // 1. DYNAMIC OVERRIDE: Is a specific mapped collection active?
      let activeMap = null;
      if (state.requiredTags.includes('bestselling')) activeMap = sortMaps['bestselling'];
      else if (state.requiredTags.includes('sets-and-bundles')) activeMap = sortMaps['sets-and-bundles'];
      else if (state.requiredTags.includes('signed-books')) activeMap = sortMaps['signed-books'];

      // If one of those specific filters is clicked, strictly sort using its map
      if (activeMap) {
        const indexA = activeMap.indexOf(a.handle);
        const indexB = activeMap.indexOf(b.handle);
        const posA = indexA !== -1 ? indexA : 9999;
        const posB = indexB !== -1 ? indexB : 9999;
        return posA - posB;
      }

      // 2. THE NEW AUTHOR & SERIES CUSTOM SORTING
      // If comparing two of the same type (Authors vs Authors, or Series vs Series)
      if (a.type === b.type && (a.type === 'author' || a.type === 'series')) {
        // Parse the integer securely. If left blank in Shopify, default to 9999 so it goes to the bottom.
        const parseSort = (val) => {
          const num = parseInt(val, 10);
          return isNaN(num) ? 9999 : num;
        };
        
        const sortA = parseSort(a.sort);
        const sortB = parseSort(b.sort);

        if (sortA !== sortB) {
          return sortA - sortB; // Ascending order: 1, 2, 3...
        }
        
        // Failsafe: If they have the exact same sort number (or are both missing it), sort alphabetically by title
        return (a.title || '').localeCompare(b.title || '');
      }

      // 3. THE GLOBAL HIERARCHY RANKING (For the 'All' view or Search Results)
      // This ensures that when viewing a mixed grid, it stays highly organized.
      const typeRank = {
        'book': 1,
        'merch': 2, 
        'author': 3,   
        'series': 4,  
        'other': 5   
      };

      const rankA = typeRank[a.type] || 99;
      const rankB = typeRank[b.type] || 99;

      // If they are different types, sort by their rank
      if (rankA !== rankB) {
        return rankA - rankB;
      }

      // 4. MERCH SPECIFIC SORTING (If both items are Merch)
      if (a.type === 'merch' && b.type === 'merch') {
        const merchMap = sortMaps['all-non-book-merch'] || [];
        const indexA = merchMap.indexOf(a.handle);
        const indexB = merchMap.indexOf(b.handle);
        const posA = indexA !== -1 ? indexA : 9999;
        const posB = indexB !== -1 ? indexB : 9999;
        return posA - posB;
      }

      // 5. BOOK SPECIFIC SORTING (Strictly Alphabetical)
      if ((a.type === 'book' || a.type === 'books') && (b.type === 'book' || b.type === 'books')) {
         return (a.title || '').localeCompare(b.title || '');
      }

      // Final Fallback
      return 0; 
    });


    // Step D: Render the final result
    renderGrid(results, gridContainer);
  }

  // =======================================================================
  // 3. EVENT LISTENERS (Updating the State)
  // =======================================================================
  
  // -- A. Search Bar Listener --
  if (searchInput) {
    searchInput.addEventListener('input', function(e) {
      state.searchText = e.target.value.trim();
      applyFilters(); 
    });
  }

  // -- B. Icon Button Listeners --
  if (filterButtons.length > 0) {
    filterButtons.forEach(btn => {
      btn.onclick = function(e) {
        e.preventDefault(); 
        
        // Handle UI
        filterButtons.forEach(b => b.classList.remove('active'));
        this.classList.add('active');
        this.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' });

        // Update State
        const rawFilter = this.getAttribute('data-filter');
        const filterValue = rawFilter && rawFilter.trim() !== '' ? rawFilter : 'all';
        
        if (filterValue !== 'all') {
          state.requiredTags = filterValue.split(',').map(tag => tag.trim().toLowerCase());
        } else {
          state.requiredTags = []; // Reset to 'all'
        }

        applyFilters();
      };
    });
  } else if (hubData.length > 0) {
    // Failsafe: if no buttons exist but we have data, just render it all
    renderGrid(hubData, gridContainer);
  }

  // =======================================================================
  // 4. URL ROUTING (Deep-Linking on Load)
  // =======================================================================
  const urlParams = new URLSearchParams(window.location.search);
  const targetFilter = urlParams.get('filter');
  
  let buttonToClick = null;
  let isRawSearch = false; 

  // Check the URL (Removed the requirement for buttons to exist first)
  if (targetFilter) {
    try {
      const cleanTarget = decodeURIComponent(targetFilter).trim().toLowerCase();
      
      // Step A: Hunt for a matching button
      if (filterButtons.length > 0) {
        for (const btn of filterButtons) {
          const btnFilterData = btn.getAttribute('data-filter') || '';
          const btnTargets = btnFilterData.split(',').map(t => t.trim().toLowerCase());
          const btnTitle = btn.innerText.trim().toLowerCase();
          
          if (btnTargets.includes(cleanTarget) || btnTitle === cleanTarget) {
            buttonToClick = btn;
            break; 
          }
        }
      }

      // Step B: Orphan tag check
      if (!buttonToClick) {
        isRawSearch = true;
      }
    } catch (e) {
      console.warn("Hub Engine: Malformed URL parameter ignored.");
    }
  }

  // Execute Initial Load
  if (buttonToClick) {
    // SCENARIO 1: Matching icon found -> Click it!
    buttonToClick.click();
    
  } else if (isRawSearch && targetFilter) {
    // SCENARIO 2: Phantom Search -> Route it to the Search Bar!
    const decodedTarget = decodeURIComponent(targetFilter);
    const cleanTarget = decodedTarget.trim().toLowerCase();
    
    // Clear any active UI highlights from buttons
    filterButtons.forEach(b => b.classList.remove('active'));
    
    // Inject the orphan tag into the text state
    state.searchText = cleanTarget;
    
    // Visually populate the search bar so the user knows what is happening
    if (searchInput) {
      searchInput.value = decodedTarget;
    }
    
    applyFilters();
    
  } else {
    // SCENARIO 3: Standard page load 
    const defaultButton = document.querySelector('.hub-icon-btn.active');
    if (defaultButton) {
      defaultButton.click(); 
    } else if (filterButtons.length > 0) {
      filterButtons[0].click(); // Fallback to first button
    } else {
      applyFilters(); // Renders everything if no buttons exist
    }
  }
}

// =========================================================================
// 5. THE RENDER ENGINE
// =========================================================================
function renderGrid(data, container) {
  container.innerHTML = ''; 

  if (data.length === 0) {
    container.innerHTML = '<p class="no-results" style="grid-column: 1 / -1; text-align: center; padding: 2rem;">No items match your criteria.</p>';
    return;
  }

  const fragment = document.createDocumentFragment();

  data.forEach(item => {
    const card = document.createElement('div');
    card.className = `hub-card type-${item.type}`;
    const imageUrl = item.image || 'data:image/svg+xml,%3Csvg xmlns="http://www.w3.org/2000/svg" width="400" height="600"%3E%3Crect width="400" height="600" fill="%23e8e8e8"/%3E%3C/svg%3E';
// Check if the item is on sale, and dynamically insert the percentage
    const badgeText = item.discount_percent > 0 ? `Sale ${item.discount_percent}%` : 'Sale';
    const saleBadgeHtml = item.on_sale ? `<span class="hub-sale-badge">${badgeText}</span>` : '';
    
    card.innerHTML = `
      <a href="${item.url}" class="hub-card-link" style="text-decoration: none; color: inherit;">
        <div class="hub-card-image">
          ${saleBadgeHtml}
          <img src="${imageUrl}" alt="${item.title}" loading="lazy" />
        </div>
        <div class="hub-card-info">
          <span class="hub-card-badge">${item.type.toUpperCase()}</span>
          <h3 style="font-size: 1.1rem;">${item.title}</h3>
          ${item.price ? `<span class="hub-card-price">From ${item.price}</span>` : ''}
        </div>
      </a>
    `;
    fragment.appendChild(card);
  });

  container.appendChild(fragment);
}

// Execution Triggers
if (document.readyState === 'complete' || document.readyState === 'interactive') {
  initHubLogic();
} else {
  document.addEventListener('DOMContentLoaded', initHubLogic);
}
document.addEventListener('shopify:section:load', initHubLogic);